import { Grid } from "@mui/material";
import AsyncSelect from "../../../../AsyncSelect";
import CustomDatePicker from "../../../../CustomDatePicker";
import Input from "../../../../Input";
import { BANK_OPTIONS } from "./payment-constant";
import dayjs from "dayjs";

export const PaymentBankFields = ({ formik }: { formik: any }) => {
  return (
    <Grid
      container
      spacing={2}
      sx={{
        width: "100%",
      }}
    >
      <Grid size={6}>
        <AsyncSelect
          label="Payment Method"
          placeholder="Select"
          value={(formik.values as any)?.bankPaymentMode}
          name="active"
          options={BANK_OPTIONS}
          onChange={(option) => formik.setFieldValue("bankPaymentMode", option)}
        />
      </Grid>
      <Grid size={6}>
        <Input
          label="Check No/NFT/Trans.Id"
          textFieldProps={{
            placeholder: "Enter Check No/NFT/Trans.Id",
            name: "transactionId",
            onChange: formik.handleChange,
            value: (formik.values as any)?.transactionId,
          }}
        />
      </Grid>
      <Grid size={6}>
        <CustomDatePicker
          minDate={dayjs(new Date())}
          label="Date"
          name="paymentDate"
          value={formik.values?.paymentDate}
          onChange={(val) => formik.setFieldValue("paymentDate", val)}
        />
      </Grid>
      <Grid
        sx={{
          mt: 2,
        }}
        size={12}
      >
        <Input
          label="Note"
          textFieldProps={{
            placeholder: "Enter Note",
            rows: 3,
            multiline: true,
            name: "note",
            onChange: formik.handleChange,
            value: formik.values.note,
          }}
        />
      </Grid>
    </Grid>
  );
};
